import React, { useState, useEffect } from "react";
import { withRouter } from 'react-router-dom';
import Icon from "../../Icon/Icon";
import ActionButton from "../ActionButton/ActionButton";
import Switch from "../Switch/Switch";
import { useGlobalValue } from "../../../state/GlobalProvider";
import styles from "./AuditNote.module.sass";
const AuditNote = props => {
  const {
    data,
    match
  } = props;
  const [inputs, setInputs] = useState({
    message: (data || {}).message
  });
  const [justified, setJustified] = useState(false);
  const {
    i18n,
    submitAuditNote,
    params,
    auditNote
  } = useGlobalValue();
  useEffect(() => {
    setInputs({
      message: (data || {}).message
    });
    setJustified((data || {}).justified === 1 && true);
  }, [data]);
  const handleSubmit = e => {
    e && e.preventDefault();
    let value = 0;
    if (justified) {
      value = 1;
    }
    if (submitAuditNote) {
      submitAuditNote({
        auditNote: {
          ...inputs,
          justified: value,
          findingId: params.id,
          id: (data || {}).id
        },
        ...params
      });
    } else {
      console.error("No submitAuditNote action provided by GlobalProvider");
    }
  };
  const handleChange = e => {
    e.persist();
    setInputs(inputs => ({
      ...inputs,
      [e.target.name]: e.target.value
    }));
  };
  if (isNaN(match.params.entityId)) return true;
  return /*#__PURE__*/React.createElement("div", {
    className: styles["root"]
  }, /*#__PURE__*/React.createElement("div", {
    className: `${styles["content"]}`
  }, /*#__PURE__*/React.createElement("div", {
    className: styles["audit-container"]
  }, /*#__PURE__*/React.createElement("h3", null, i18n("Audit Notes")), /*#__PURE__*/React.createElement("div", {
    className: styles["audit-form"]
  }, /*#__PURE__*/React.createElement(Switch, {
    name: i18n(`In accordance?`),
    checked: justified,
    onChange: e => {
      setJustified(e.target.value);
    }
  }), /*#__PURE__*/React.createElement("h5", null, i18n("Justification:")), /*#__PURE__*/React.createElement("textarea", {
    name: "message",
    className: styles["audit-note-textarea"],
    onChange: handleChange,
    value: inputs["message"] || "",
    required: true
  }), params.id === (auditNote || {}).id ? (auditNote || {}).message === "ERROR" ? /*#__PURE__*/React.createElement("span", {
    className: `${styles["message"]} ${styles["message-danger"]}`
  }, (auditNote || {}).message, /*#__PURE__*/React.createElement(Icon, {
    name: "danger",
    className: `${styles["danger"]} ${styles["icon-danger"]}`,
    key: 1
  })) : /*#__PURE__*/React.createElement("span", {
    className: `${styles["message"]} ${styles["message-sucess"]}`
  }, (auditNote || {}).message, /*#__PURE__*/React.createElement(Icon, {
    name: "success",
    className: `${styles["sucess"]} ${styles["icon-sucess"]}`,
    key: 1
  })) : "", /*#__PURE__*/React.createElement(ActionButton, {
    className: styles["action-button"],
    primary: true,
    type: "button",
    onClick: handleSubmit
  }, /*#__PURE__*/React.createElement("strong", null, i18n("Submit")))))));
};
export default withRouter(AuditNote);